import { Lokasjon } from '../../../models';
import { client } from '../../client';
import { getQueryURL } from '../requestService';
import { SubEntityRequestService } from '../subEntityRequestService';

export default class DatabaseLokasjonerService extends SubEntityRequestService<Lokasjon>
{
    constructor() {
        super('database', 'lokasjon');
    }
    deleteLokasjoner = async (baseId: string, ids: number[]) => client.delete<void>(getQueryURL(`${this.getBaseRoute(baseId)}`, {ids}));
}